export default {"src":"/_next/static/media/ActiveBadge.1693555b.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};